import { useEffect, useState } from 'react';

const useApi = (apiFunc) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(()=>{
    setData(null); // reset previous data
    setError(null); // optionally reset error
  },[])

  const clearHook = ()=>{
    setData(null); // reset previous data
    setError(null); // optionally reset error
  }
  const request = async (...args) => {
    setLoading(true);
    // console.log(isLoading)
    
    try {
      const response = await apiFunc(...args);
      if(response?.status<400){
        console.log(response)
      setData(response);
      setError(null);
      return response;
      }else{
      setData(null);
      setError(response);
      return response
      }
    } catch (err) {
      setError(err);
      setData(null);
    } finally {
      setLoading(false);
      // setError(null);
      // setData(null);
    }
    console.log(isLoading)

  };

  return { data, error, isLoading, request, clearHook };
};

export default useApi